import React from 'react';
import PropTypes from 'prop-types';
import GenericMultiSelect from './GenericMultiSelect';
import { updateSyncMultiselect } from '../../../modules/DataExports/redux/actions';

const regions = [
  { label: 'Africa', value: 'africa' },
  { label: 'Antarctica', value: 'antarctica' },
  { label: 'Asia', value: 'asia' },
  { label: 'Europe', value: 'europe' },
  { label: 'Latin America and the Caribbean', value: 'latinAmerica' },
  { label: 'North America', value: 'northAmerica' },
];

const RegionMultiSelect = props => (
  <div>
    <GenericMultiSelect
      action={updateSyncMultiselect}
      dispatch={props.dispatch}
      identifier={props.identifier}
      options={regions}
      placeholder='Ex. North America'
      value={props.value}
    />
  </div>
);

RegionMultiSelect.propTypes = {
  dispatch: PropTypes.func,
  identifier: PropTypes.string,
  value: PropTypes.array,
};

export default RegionMultiSelect;



// WEBPACK FOOTER //
// ./src/components/lib/RegionMultiSelect.js